import React from "react";
import {
  Dialog,
  DialogContent as ShadcnDialogContent,
} from "@/components/ui/dialog";
import AuthDialogContentComponent from "@/components/AuthDialogContent";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthDialogOpen } from "../store/auth/authSlice";
import { signInWithGoogle } from "../store/auth/authActions";

const AuthDialog = () => {
  const dispatch = useDispatch();
  const { isAuthDialogOpen, authDialogDefaultTab, redirectPage } = useSelector(
    (state) => state.auth,
  );

  const handleOpenChange = (open) => {
    dispatch(setIsAuthDialogOpen(open));
  };

  const handleAuthSuccess = () => {
    dispatch(setIsAuthDialogOpen(false));
  };

  const handleGoogleAuth = async () => {
    try {
      await dispatch(signInWithGoogle()).unwrap();
    } catch (error) {
      console.error("Google authentication failed:", error);
    }
  };

  if (!isAuthDialogOpen) {
    return null;
  }

  return (
    <Dialog open={isAuthDialogOpen} onOpenChange={handleOpenChange}>
      <ShadcnDialogContent className="sm:max-w-[425px] md:max-w-[480px] bg-gradient-to-br from-background via-background to-secondary/10 rounded-xl shadow-2xl border-border/20 max-h-[90vh] overflow-hidden p-0 flex flex-col">
        <AuthDialogContentComponent
          defaultTab={authDialogDefaultTab}
          redirectPage={redirectPage}
          onAuthSuccess={handleAuthSuccess}
          onCancel={() => dispatch(setIsAuthDialogOpen(false))}
          onGoogleAuth={handleGoogleAuth}
        />
      </ShadcnDialogContent>
    </Dialog>
  );
};

export default AuthDialog;
